import React from "react";
import { useSelector } from "react-redux";
import Product from "./Product";

const Products = () => {
    const products = useSelector((state) => state?.products);

    return (
        <div className="col-span-12 sm:col-span-12 md:col-span-7 lg:col-span-8 xxl:col-span-8">
            {products?.map(({ id, price, productName, quantity }) => {
                return (
                    <Product
                        key={id}
                        id={id}
                        price={price}
                        productName={productName}
                        quantity={quantity}
                    />
                );
            })}
        </div>
    );
};

export default Products;
